import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f0e6e04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-user w-full h-full flex flex-col" }
const _hoisted_2 = { class: "edit-user--header-container flex mt-[24px] top-[24px] px-[24px]" }
const _hoisted_3 = { class: "flex justify-between items-center mb-4 w-full" }
const _hoisted_4 = {
  "data-testid": "users-editor--title",
  class: "text-[20px] text-Text/text_high font-gordita-medium"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times text-[24px] !mr-0" }, null, -1))
const _hoisted_6 = { class: "flex justify-start items-center w-full mb-6" }
const _hoisted_7 = {
  class: "rounded-sm",
  "data-testid": "users-editor--toggle-status-tooltip-content"
}
const _hoisted_8 = {
  "data-testid": "users-editor--toggle-status-text",
  class: "ml-2 text-Text/text_medium gordita-regular-13"
}
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center items-center h-5"
}
const _hoisted_10 = { class: "user-last-login" }
const _hoisted_11 = {
  "data-testid": "users-editor--last-login-title",
  class: "text-Text/text_medium font-gordita-regular text-[13px] ml-4"
}
const _hoisted_12 = {
  "data-testid": "users-editor--last-login-val",
  class: "text-Text/text_medium font-gordita-regular text-[13px] ml-1"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1))
const _hoisted_14 = { class: "overflow-x-hidden overflow-y-auto h-0 grow max-w-[400px] px-[24px]" }
const _hoisted_15 = { class: "edit-user--user-info-container" }
const _hoisted_16 = { class: "edit-user--user-info-header font-gordita-medium text-[14px]" }
const _hoisted_17 = { class: "edit-user--Account-info" }
const _hoisted_18 = { class: "mb-10" }
const _hoisted_19 = ["password-container-visible"]
const _hoisted_20 = { class: "edit-user--user-info-container mt-[32px]" }
const _hoisted_21 = { class: "edit-user--user-info-header font-gordita-medium text-[14px]" }
const _hoisted_22 = { class: "edit-user--user-info" }
const _hoisted_23 = { class: "edit-user--footer" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-[14px]" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "uis uis-lock-open-alt" }),
  /*#__PURE__*/_createElementVNode("span", null, "Unlock")
], -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Save")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, inject, ref, onUnmounted } from 'vue';
import { User_Role, User_Status, User_UpdateInput, useUsersQuery } from '@/graphql/codegen/generated/graphql';
import { IncrediButton, IncrediField, IncrediForm, IncrediSelect, IncrediToggle, IncrediTooltip } from 'incredi-ui';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useNotify } from '@/services/notify/notify';
import { useI18n } from 'vue-i18n';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { IKRightDrawer } from '@/views/Layout/RightDrawer.InjectionKeys';
import elementIds from '@/const/elementIds.json';
import { dateUtils } from '@/services/dateUtils';
import { MAP_COLUMNS_To_User_Roles, MAP_User_Roles_To_Show } from './users-table.const';
import { useUsersPage } from '../users.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'editUser',
  setup(__props) {

const rightDrawer = inject(IKRightDrawer);
const platformAuthentication = inject(IKPlatformAuthentication);
const users = useUsersQuery({}, { fetchPolicy: 'cache-first' });

const { toastMessage } = useNotify();
const { t } = useI18n();

const tooltip = ref(false);
const isPasswordChangeOpen = ref(false);
const usersPage = useUsersPage();
const isUserLocked = computed(() => usersPage?.usersTable.selectedUser.get.userData.value?.status === User_Status.Locked);
const isFormUserInactive = computed(() => usersPage?.editUserForm.form.values?.status === User_Status.Inactive);

const closeDrawer = () => {
  usersPage?.usersTable.selectedUser.clear();
  rightDrawer?.close();
};

const toggleUserStatus = () => {
  if (!usersPage) return;
  const activeState = isUserLocked.value ? User_Status.Locked : User_Status.Active;
  usersPage.editUserForm.fields.status.value.value = isFormUserInactive.value ? activeState : User_Status.Inactive;
};

const togglePasswordChange = () => {
  isPasswordChangeOpen.value = !isPasswordChangeOpen.value;
};

const handleRoleUpdate = (role: User_Role) => {
  if (!usersPage) return;
  const gridAdminNumber = users.result.value?.users?.filter(user => user?.role === User_Role.GridAdmin && user.status === User_Status.Active).length;
  // returning true if user is last admin. If user is last admin, he can't change his role.
  const isUserLastAdmin =
    usersPage?.usersTable.selectedUser.get.userData.value?.role === User_Role.GridAdmin &&
    usersPage?.usersTable.selectedUser.get.userData.value?.status === User_Status.Active &&
    gridAdminNumber === 1 &&
    role !== User_Role.GridAdmin;
  if (isUserLastAdmin) {
    toastMessage(t('usersTable.userRole.lastAdmin'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    return;
  }
  usersPage.editUserForm.fields.role.value.value = role;
};

const handleTooltip = (value: boolean) => {
  tooltip.value = value;
};

// unlocking user by changing its status from 'Locked' to 'Active'
const unlockUser = async () => {
  const data: User_UpdateInput = {
    status: User_Status.Active,
  };
  const userUnlocked = await usersPage?.GQL.mutateUser(data);
  if (userUnlocked) {
    toastMessage(t('usersTable.userEdit.unlocked'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
    if (!usersPage) return;
    const { values } = usersPage.editUserForm.form;
    if (usersPage.editUserForm.form.meta.value.dirty) usersPage.editUserForm.fields.status.resetField({ value: User_Status.Active });
    else {
      usersPage.editUserForm.form.resetForm({
        values: {
          ...values,
          status: User_Status.Active,
        },
      });
    }
  }
};
onUnmounted(() => {
  usersPage?.editUserForm.resetFormToInitialState();
});

return (_ctx: any,_cache: any) => {
  const _component_vl = _resolveComponent("vl")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      (_unref(usersPage))
        ? (_openBlock(), _createBlock(_unref(IncrediForm), {
            key: 0,
            "data-testid": "users-editor",
            class: "w-full h-full flex flex-col border-l border-l-System/app_border wide-scroller",
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_unref(usersPage)?.editUserForm.submitUserEditorForm()), ["prevent"])),
            onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => ($event.preventDefault()), ["enter"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(usersPage)?.usersTable.selectedUser.get.userData.value?.userName), 1),
                    _createVNode(_unref(IncrediButton), {
                      "data-testid": _unref(elementIds).users.editor.buttons.close,
                      design: "ghost-grey",
                      fab: "",
                      class: "flex w-[32px] h-[32px] items-center justify-center transition-all !duration-[200ms] -mr-1",
                      size: 'small',
                      onClick: closeDrawer
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["data-testid"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(IncrediTooltip), {
                      "data-testid": "users-editor--toggle-status-tooltip",
                      direction: "bottom-sticky-left",
                      "model-value": tooltip.value && _unref(platformAuthentication)?.accessTokenDecoded.value?.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                      delay: 200,
                      hover: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = (value)=>handleTooltip(value))
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('usersTable.userEdit.editForm.selfStatus')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(IncrediToggle), {
                          "data-testid": _unref(elementIds).users.editor.buttons.activeToggle,
                          "model-value": !_unref(isFormUserInactive),
                          disabled: _unref(platformAuthentication)?.accessTokenDecoded.value?.id === _unref(usersPage)?.usersTable.selectedUser.get.userData.value?.id,
                          onClick: _withModifiers(toggleUserStatus, ["stop","prevent"])
                        }, null, 8, ["data-testid", "model-value", "disabled", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["model-value"]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(!_unref(isFormUserInactive) ? _unref(User_Status).Active : _unref(usersPage)?.editUserForm.form.values.status), 1),
                    (_unref(usersPage)?.usersTable.selectedUser.get.userData.value?.lastLogin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_vl, { class: "divider" }),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('usersTable.userEdit.editForm.lastLogin')), 1),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(dateUtils).getFormattedDate(_unref(usersPage)?.usersTable.selectedUser.get.userData.value?.lastLogin)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_13
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('usersTable.userEdit.editForm.accountHeader')), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_unref(IncrediField), {
                          maxlength: 20,
                          "data-testid": _unref(elementIds).users.editor.inputs.username,
                          error: !!_unref(usersPage).editUserForm.form.errors.value.userName,
                          "error-message": _unref(usersPage).editUserForm.form.errors.value.userName,
                          modelValue: _unref(usersPage).editUserForm.fields.userName.value.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(usersPage).editUserForm.fields.userName.value.value) = $event)),
                          onChange: _cache[2] || (_cache[2] = () => _unref(usersPage)?.editUserForm.fields.userName.validate()),
                          name: "username",
                          label: "Username",
                          "field-type": "text",
                          size: "big"
                        }, null, 8, ["data-testid", "error", "error-message", "modelValue"])
                      ]),
                      _createElementVNode("div", {
                        "password-container-visible": isPasswordChangeOpen.value,
                        class: "flex flex-col password-change-container gap-10"
                      }, [
                        _createVNode(_unref(IncrediField), {
                          "data-testid": _unref(elementIds).users.editor.inputs.password,
                          error: !!_unref(usersPage).editUserForm.form.errors.value.password,
                          "error-message": _unref(usersPage).editUserForm.form.errors.value.password,
                          modelValue: _unref(usersPage).editUserForm.fields.password.value.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(usersPage).editUserForm.fields.password.value.value) = $event)),
                          onChange: _cache[4] || (_cache[4] = () => _unref(usersPage)?.editUserForm.fields.password.validate()),
                          name: "password",
                          "field-type": "password",
                          label: "New Password",
                          size: "big"
                        }, null, 8, ["data-testid", "error", "error-message", "modelValue"]),
                        _createVNode(_unref(IncrediField), {
                          "data-testid": _unref(elementIds).users.editor.inputs.confirmPassword,
                          error: !!_unref(usersPage).editUserForm.form.errors.value.confirmPassword,
                          "error-message": _unref(usersPage).editUserForm.form.errors.value.confirmPassword,
                          modelValue: _unref(usersPage).editUserForm.fields.confirmPassword.value.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(usersPage).editUserForm.fields.confirmPassword.value.value) = $event)),
                          onChange: _cache[6] || (_cache[6] = () => _unref(usersPage)?.editUserForm.fields.confirmPassword.validate()),
                          name: "confirmPassword",
                          label: "Confirm New Password",
                          "field-type": "password",
                          size: "big"
                        }, null, 8, ["data-testid", "error", "error-message", "modelValue"]),
                        _createVNode(_unref(IncrediButton), {
                          "data-testid": _unref(elementIds).users.editor.buttons.passwordChangeCancelBtn,
                          design: "secondary-red",
                          size: "big",
                          onClick: _withModifiers(togglePasswordChange, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('usersTable.userEdit.editForm.passwordChangeCancelBtn')), 1)
                          ]),
                          _: 1
                        }, 8, ["data-testid", "onClick"])
                      ], 8, _hoisted_19),
                      (!isPasswordChangeOpen.value)
                        ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                            key: 0,
                            "data-testid": _unref(elementIds).users.editor.buttons.passwordChangeBtn,
                            design: "secondary-green",
                            "password-container-visible": isPasswordChangeOpen.value,
                            size: "big",
                            class: "change-password-btn",
                            onClick: _withModifiers(togglePasswordChange, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('usersTable.userEdit.editForm.passwordChangeBtn')), 1)
                            ]),
                            _: 1
                          }, 8, ["data-testid", "password-container-visible", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('usersTable.userEdit.editForm.detailsHeader')), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_unref(IncrediSelect), {
                        "data-testid": _unref(elementIds).users.editor.inputs.role,
                        items: Object.values(_unref(MAP_User_Roles_To_Show)),
                        "model-value": _unref(MAP_User_Roles_To_Show)[_unref(usersPage)?.editUserForm.form.values?.role as User_Role],
                        label: "Role",
                        size: "big",
                        direction: "bottom-sticky-left",
                        "override-style": { width: '352px' },
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = (value) =>handleRoleUpdate(_unref(MAP_COLUMNS_To_User_Roles)[value as keyof typeof MAP_COLUMNS_To_User_Roles]))
                      }, null, 8, ["data-testid", "items", "model-value"]),
                      _createVNode(_unref(IncrediField), {
                        "data-testid": _unref(elementIds).users.editor.inputs.firstName,
                        error: !!_unref(usersPage).editUserForm.form.errors.value.firstName,
                        "error-message": _unref(usersPage).editUserForm.form.errors.value.firstName,
                        modelValue: _unref(usersPage).editUserForm.fields.firstName.value.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(usersPage).editUserForm.fields.firstName.value.value) = $event)),
                        name: "First Name",
                        label: "First Name (Optional)",
                        maxlength: 30,
                        size: "big"
                      }, null, 8, ["data-testid", "error", "error-message", "modelValue"]),
                      _createVNode(_unref(IncrediField), {
                        "data-testid": _unref(elementIds).users.editor.inputs.lastName,
                        error: !!_unref(usersPage).editUserForm.form.errors.value.lastName,
                        "error-message": _unref(usersPage).editUserForm.form.errors.value.lastName,
                        modelValue: _unref(usersPage).editUserForm.fields.lastName.value.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(usersPage).editUserForm.fields.lastName.value.value) = $event)),
                        name: "Last Name",
                        label: "Last Name (Optional)",
                        maxlength: 30,
                        size: "big"
                      }, null, 8, ["data-testid", "error", "error-message", "modelValue"]),
                      _createVNode(_unref(IncrediField), {
                        "data-testid": _unref(elementIds).users.editor.inputs.email,
                        error: !!_unref(usersPage).editUserForm.form.errors.value.email,
                        "error-message": _unref(usersPage).editUserForm.form.errors.value.email,
                        modelValue: _unref(usersPage).editUserForm.fields.email.value.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(usersPage).editUserForm.fields.email.value.value) = $event)),
                        onChange: _cache[11] || (_cache[11] = () => _unref(usersPage)?.editUserForm.fields.email.validate()),
                        name: "Email",
                        label: "Email (Optional)",
                        size: "big"
                      }, null, 8, ["data-testid", "error", "error-message", "modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex h-full pb-[14px] mx-[24px]", _unref(isUserLocked) && !_unref(isFormUserInactive) ? 'justify-between' : 'justify-end'])
                  }, [
                    (_unref(isUserLocked) && !_unref(isFormUserInactive))
                      ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                          key: 0,
                          "data-testid": _unref(elementIds).users.editor.buttons.unlock,
                          type: "reset",
                          design: "primary-black",
                          size: "big",
                          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (unlockUser()), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }, 8, ["data-testid"]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IncrediButton), {
                      "data-testid": _unref(elementIds).users.editor.buttons.save,
                      class: "justify-end",
                      type: "submit",
                      design: "primary-green",
                      size: "big",
                      disabled: !_unref(usersPage)?.editUserForm.form.meta.value.dirty,
                      onClick: _cache[13] || (_cache[13] = 
                (...args) => {
                  isPasswordChangeOpen.value = false;
                  _unref(usersPage)?.editUserForm.submitUserEditorForm(...args);
                }
              )
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }, 8, ["data-testid", "disabled"])
                  ], 2)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})